import type { FaireThemeEntity } from "../../entity_types/theme";

export const pocket_sized_pure_wellness: FaireThemeEntity = {
  token: "pocket-sized-pure-wellness",
  type: "theme",
  name: "Pocket-Sized Pure Wellness",
  description: "Clean, travel-ready sprays and balms to keep your customers healthy wherever they go. Add these to your collection of natural remedies.",
  teaser: "Elsie Rose LLC frequently orders from brands like Rowe Casa Organics and stocks various essential oil blends, aromatherapy mists, and healing salves, showing a clear dedication to portable wellness.",
  detail: "The additional_context features the Immunity Spray (2 oz) from Rowe Casa Organics, which is designed for shared spaces and travel, perfectly matching your existing inventory of essential oils.",
  bgColor: "#FFD4FF",
  tileBgColor: "#6b6337",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_mna0e5vjkz",
    "p_rcszdb9nmw",
    "p_v9vh5q5drf",
    "p_cwqnuvnzyb",
    "p_81zhmnckey",
    "p_7cmrcr22c8",
    "p_8d525ha9gf",
    "p_4k5tdmn3zz",
    "p_dq7xq8yxvc",
    "p_kzf4azpurn",
    "p_qd8p5u686e",
    "p_7kdbzz3rsz",
    "p_62t4z97e3y",
    "p_t3dngtatcj",
    "p_yrefr6anbd",
    "p_6lbg51g67p",
    "p_dc7y49x3v4",
    "p_sx2452kege",
    "p_eay9k97q29",
    "p_7qpk3n54c5",
    "p_7uowp8m3yn",
    "p_6bvhqf29gr",
    "p_jhhtyb48k8",
    "p_mxy8g2czm6",
    "p_wpc83d8ss5",
    "p_y6s9dvyvsd",
    "p_970pfwg424",
    "p_60yjgd5qev",
    "p_beqmyztjfh",
    "p_vrp2jmxbp9",
    "p_axe7ab7zc4",
    "p_xhg3pf6ywk",
    "p_c9orvefo9d",
    "p_rrjkth3rh3",
    "p_epf268mxjw",
    "p_gv3kb8c6wg",
    "p_acuwf4xtgw",
    "p_6565k3j9h8",
    "p_kgwh45nu49",
    "p_tumgubh6yp",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
